/* Gogo Language Texts
Table of Contents
01.General
02.User Login, Logout, Register
03.Menu
04.Error Page
*/
import countryList from "./tr_country_list";

export default () => {
  return {
    /* 00. Languages */
    en: "İngilizce",
    tr: "Türkçe",
    de: "Almanca",
    /* 01.General */
    countryList,
    "Network Error!": "Bağlantı hatası!",
    "Please check your internet connection": "Lütfen internet bağlantınızı kontrol edin",
    "Please allow notifications": "Lütfen bildirimlere izin veriniz",
    Reconnecting: "Yeniden bağlanılıyor",
    "Retry Now": "Şimdi yeniden dene",
    "You are currently offline": "Şu an çevrimdışısınız",
    "Old Version": "Eski Versiyon",
    "Your version is old. Please refresh your browser to reload!":
      "Kullandığınız staffapp versiyonu güncel değil. Lüften burayı tıklayarak sayfayı yenileyiniz!",
    connected_to_the_server: "Çevrimiçi",
    this_user_does_not_have_permission_for_this_hotel: "Bu kullanıcının bu otel için yetkisi yok",
    permission_error: "Yetki Hatası",
    dateOptions: {
      yearFormat: "numeric",
      monthFormat: "long",
      dayFormat: "2-digit",
      locale: "tr"
    },
    click_to_load: "Daha fazla yüklemek için tıklayınız.",
    click_to_load_until: "Şu tarihten itibaren gösteriliyor: ",
    click_to_load_number: " Gösterilen (",
    seen_all: "Tamamını gördünüz.",
    birthdate_format: "DD/MM/YY",
    "form.valid.firstname": "İsim zorunlu alan",
    "form.valid.lastname": "Soyisim zorunlu alan",
    "form.valid.price": "Tutar zorunlu alan ve sadece sayılardan oluşmalı",
    "form.valid.email": "E-mail doğru değil",
    "form.valid.mobile": "Telefon numarası doğru değil - örn: +90555xxxxxxx",
    "form.valid.roomnumber": "Oda numarası geçerli değil",
    "form.valid.decimal": "Küsür tutarı sadece sayılardan oluşmalı",
    "link.webeeCode": "Webee Kodu:",
    "link.copyCode": "Webee Kodu kopyala",
    "link.header": "Ödeme Linki Oluşturma",
    "link.modalheader": "Link",
    "link.copy": "Linki Kopyala",
    "link.error": "Bir hata oluştu, lütfen tekrar deneyin",
    "createQr.create_link": "Link ile indirmek için QR",
    "createQr.create_booking_with_pms": "PMS için QR",
    "createQr.success": "Qr oluşturma başarılı",
    "createQr.error": "Bir hata oluştu, lütfen tekrar deneyin",
    "link.copied": "Link Kopyalandı",
    "link.goReport": "Rapor Sayfası",
    "report.expired": "Süresi doldu",
    "report.not_expired": "Geçerli",
    "report.header": "Rapor",
    "report.pay": "Ödendi",
    "report.no_payments": "Ödeme Bulunamadı",
    "report.not_pay": "Ödenmedi",
    "report.permisson_error_payments": "Buraya erişim izniniz bulunmamaktadır.",
    "forms.firstname": "İsim",
    "forms.lastname": "Soyisim",
    "forms.price": "Tutar",
    "forms.email": "E-mail",
    "forms.mobile": "Telefon No",
    "forms.phone_number": "+90xxxxxxxxxx",
    "forms.start_date": "Başlangıç tarihi",
    "forms.end_date": "Bitiş tarihi",
    "forms.generate": "URL üret",
    "forms.check_in_check_out": "Check-In / Check-Out:",
    "forms.please_select": "Lütfen seçiniz",
    "forms.create": "Oluştur",
    "forms.checkin": "Checkin Tarihi",
    "forms.checkout": "Checkout Tarihi",
    "forms.room_number": "Oda Numarası",
    "forms.send_sms": "SMS gönder",
    "forms.send_email": "E-mail gönder",
    "forms.select_contact": "İletişim bilgisi seçebilirsiniz",
    "forms.select_pms": "Misafir Listesi",

    /* Alacarte */
    "alacarte.food_undefined": "Bu restoran için ana yemek seçimi bulunmamaktadır.",
    "alacarte.grand_total": "Genel Toplam",
    "alacarte.total_order": "Siparişler Toplamı",
    "alacarte.restaurant_name": "Restoran Adı",
    "alacarte.request_time": "Talep Zamanı",
    "alacarte.restaurants_header": "Restoranlar",
    "alacarte.no_restaurants": "Restaurant Bulunmamaktadır",
    "alacarte.mondays": "Pazartesi",
    "alacarte.tuesdays": "Salı",
    "alacarte.wednesdays": "Çarşamba",
    "alacarte.thursdays": "Perşembe",
    "alacarte.fridays": "Cuma",
    "alacarte.saturdays": "Cumartesi",
    "alacarte.sundays": "Pazar",
    "alacarte.quota": "Kişi",
    "alacarte.days": "Günler",
    "alacarte.success": "Başarılı",
    "alacarte.reservation_slot": "Reservasyon Slotu",
    "alacarte.addSlot": "Yeni Ekle",
    "alacarte.removeSlot": "Kaldır",
    "alacarte.stop_res_before_opens_at": "Restaurant açılış zamanından kaç dakika önce talep almaz",
    "alacarte.guest_cancel_res_before_open_at": "Misafir, talebini kaç dakika önce iptal edebilir",
    "alacarte.max_guest_count": "Rezervasyon talebi maksimum kaç kişilik yapılabilir",
    // 'alacarte.main_course': 'Ana yemek seçimi',
    "alacarte.guest_one_res_each_day": "Misafir, günde bir kere talep yapabilir",
    "alacarte.guest_one_res_per_resturant": "Misafir, her restauranta bir kere talep yapabilir",
    "alacarte.yes": "Evet",
    "alacarte.no": "Hayır",
    "alacarte.alacarte": "Alakart",
    "alacarte.no_config": "Gün ve tercih seçimi yok",
    "alacarte.newRequest": "Yeni Talep",
    "alacarte.available_seats": "Kalan kişi sayısı",
    "alacarte.info_available_seats": "Zaman seçimi bulunmuyor",
    "alacarte.main_course": "Ana Yemek",
    "alacarte.person": "Kişi",
    "alacarte.adult": "Yetişkin",
    "alacarte.adult_count": "Yetişkin Sayısı",
    "alacarte.child": "Çocuk",
    "alacarte.room_number": "Oda Numarası",
    "alacarte.name": "İsim Soyisim",
    "alacarte.notes": "Not",
    "alacarte.select_restaurant_and_slot": "Restoran ve zaman seç",
    "alacarte.people_count": "Yetişkin Sayısı",
    "alacarte.child_count": "Çocuk Sayısı",
    "alacarte.create_form": "Form Oluştur",
    "alacarte.create_request": "Talep oluştur",
    "alacarte.request_person_info": "Kişi Bilgileri",
    "alacarte.request_no_person_info": "Kişi Bilgileri Bulunmamaktadır.",
    "alacarte.input_required": "(*) zorunlu alanlar dolu olmalıdır.",
    "alacarte.print": "Yazdır",
    "alacarte.request_owner_staff": "Talep StaffApp ile oluşturuldu",
    "alacarte.allday": "Tüm Gün",
    "alacarte.count": "sayı",
    "alacarte.date": "Tarih",
    "alacarte.time": "Zaman Aralığı",
    "alacarte.total_request": "Toplam Talep",
    "alacarte.total_person": "Toplam Kişi",
    "alacarte.total_child": "Toplam Çocuk",

    /* Fast Checkin */
    "fastCheckin.guests": "Misafirler",

    /* 02.User Login, Logout, Register */
    "user.passwordChangeSuccess": "Parolanız değiştirildi",
    "user.passwordChangeError": "Bir hata oluştu, lütfen tekrar deneyin!",
    "user.signout": "Çıkış Yap",
    "user.changePassword": "Parola Değiştir",
    "user.oldPassword": "Eski Parola",
    "user.newPassword": "Yeni Parola",
    "user.confirmationCode": "Onay Kodu",
    "user.cancel": "Vazgeç",
    "user.close": "Kapat",
    "user.resetPassword": "Parola Sıfırla",
    "user.modalChangePassword": "Parola Değiştirme",
    "user.confirmPassword": "Yeni Parola Onayı",
    "user.login-title": "Giriş",
    "user.gsmNo": "GSM No:",
    "user.sendCode": "Kodu Gönder",
    "user.resendCode": "Kodu Tekrar Gönder",
    "user.register": "Kayıt Ol",
    "user.forgot-password": "Şifremi unuttum!",
    "user.email": "E-mail",
    "user.note": "Not",
    "user.all_number": "All Numarası",
    "user.password": "Şifre",
    "user.forgot-password-question": "Şifremi unuttum!",
    "user.fullname": "Full Name",
    "user.login-button": "GİRİŞ",
    "user.register-button": "KAYIT OL",
    "user.reset-password-button": "SIFIRLA",
    "user.buy": "SATIN AL",
    "user.username": "Kullanıcı Adı",
    "user.create": "Oluştur",
    "user.update": "Güncelle",

    /* 03.Menu */
    "menu.requests": "Talepler",
    "menu.bookings": "Misafir Onayı",
    "menu.fastCheckin": "Temassız Check-in",
    "menu.logs": "Misafir Log",
    "menu.lolRequests": "Land Of Legends Talepleri",
    "menu.payments": "Ödeme Ekranı",
    "menu.settings": "Ayarlar",
    "menu.template": "Şablonlar",
    "menu.reportProblem": "Problemi Raporla",
    "menu.problemDescription": "Problemin Açıklaması",
    "menu.chooseTopic": "Bir konu başlığı seçiniz",
    "menu.descriptionFieldCannotLeftEmpty": "Açıklama alanı boş bırakılamaz",
    "menu.problemSubject": "Problem Konusu",
    "menu.sendReport": "Raporu Gönder",
    "menu.sendReportConfirmMessage": "Raporu göndermek istediğinize emin misiniz?",
    "menu.link": "Ödeme Linki Oluşturma",
    "menu.report": "Ödeme Raporu",
    "menu.app": "Anasayfa",
    "menu.staff": "Staff",
    "menu.dashboards": "Panel",
    "menu.start": "Başlangıç",
    "menu.request": "Talepler",
    "menu.search": "Ara",
    "menu.chat": "Mesaj",
    "menu.blank-page": "Boş sayfa",
    "menu.empty_badge": "Yeni bir bildirim yok",
    "menu.alacarte": "Alakart Rezervasyonları",
    "menu.restaurant": "Restoranlar",
    "menu.ringTone": "Bildirim Sesi Değiştir",

    /* 04.Pages */
    "pages.error-title": "Ooops... looks like an error occurred!",
    "pages.error-code": "Error code",
    "pages.go-back-home": "GO BACK HOME",
    "pages.display-options": "Seçenekleri Görüntüle",
    "pages.orderby": "Sırala : ",

    /* 05.Request */
    "request.payable": "Ödemeli Talep",
    "request.payable_status": "Ödeme Durumu",
    "request.payable_total_amount": "Toplam Tutar",
    "request.payable_currency": "Para Birimi",
    "request.payable_payment": "Ödeme",
    "request.no_payable_details": "Henüz detay bulunmuyor",

    "request.payable_status_paid": "Ödendi",
    "request.payable_status_canceled": "İptal Edildi",
    "request.payable_status_awaiting_payment": "Ödeme Bekleniyor",

    "request.order_number": "Yapılan isteğin Yeri",
    "request.add-new": "TALEP OLUŞTUR",
    "request.add-new-title": "Yeni Talep Oluştur",
    "request.title": "Title",
    "request.comment": "Yorum",
    "request.due": "Ne zamana",
    "request.detail": "Detail",
    "request.category": "Servis Tipi",
    "request.label": "Label",
    "request.cancel": "Vazgeç",
    "request.error": "Lütfen en azından bir servis tipi seçiniz",
    "request.submit": "Gönder",
    // 'request.action': 'Action',
    "request.request_details": "Talep Detayı",
    "request.display-options": "Seçenekleri Görüntüle",
    "request.orderby": "Sırala : ",
    "request.all-tasks": "Hepsi",
    "request.pending-tasks": "Yanıt Bekleniyor",
    "request.open-tasks": "Açık",
    "request.completed-tasks": "Çözüldü",
    "request.categories": "Servis Tipleri",
    "request.clear": "Clear",
    "request.room": "Room",
    "request.collapse_all": "Hepsini daralt",
    "request.expand_all": "Hepsini genişlet",
    "request.no_booking_info": "Konaklama bilgisi yok",
    // 'request.chat_say_something': 'Misafirle buradan iletişime geçebilirsiniz...',
    "request.chat_say_something": "Misafire mesaj gönder...",
    "request.message_title": "Mesajlar",
    "request.back_button": "Geri",
    "request.clear_filters": "Filtreleri temizle",
    "request.status_open": "Açık",
    "request.status_pending": "Yanıt Bekleniyor",
    "request.status_closed": "Çözüldü",
    "request.status_canceled": "İptal Edildi",
    "request.last_update": "Son Güncelleme: ",
    "request.created_at": "Oluşturuldu: ",
    "request.due_date": "Bitiş: ",
    "request.message_view_translation": "Çeviriyi Gör",
    "request.message_show_original": "Orijinali Gör",
    "request.message_translation_detect": "ALGILANAN",
    "request.message_translation": "ÇEVRİLEN",
    "request.Creation Date": "Oluşturulma Zamanı",
    "request.Last Update": "Güncellenme Zamanı",
    "request.Due Date": "Tamamlanması Gereken Zaman",
    "request.Guest Name": "Misafir ismi",
    "request.Service Name": "Servis ismi",
    "request.Status": "Durum",
    "request.Label": "Etiket",
    "request.details": "Detay",
    "request.status": "Durum",
    "request.list_status_canceled": "İptal Edildi",
    "request.empty_message_box": "Mesaj Kutusu Boş",
    "request.message_send_button": "Gönder",
    "request.upload": "Yükle",
    "request.empty_request_list": "Talepler Boş",
    "request.wrong_request_page": "Böyle bir talep bulunamadı",
    "request.awaiting_approval_status_message":
      "Taleple ilgili herhangi bir işlem yapabilmek için öncelikle konuğun Rezervasyon durumunu güncellemeniz gerekir.",
    "request.pageUp": "Yukarı",
    "request.create_qr": "QR Oluştur",
    "request.webeepass_message": "Scan code to download app and once download is completed, scan code to activate membership.",
    "request.create_qr_pms": "WeBee PASS",
    "request.modalCreateQR": "WeBee PASS",
    "request.survey_score": "Anket Puanı",

    /* 06.Booking */
    "booking.guest_information_form": "Misafir Bilgi Formu",
    "booking.signature": "İmza",
    "booking.date": "Tarih",
    "booking.full_name": "Ad / Soyad",
    "booking.has_traveled": "Son 14 gün içinde seyahat ettim.",
    "booking.billing_address": "Fatura Adresi",
    "booking.passport_front": "Pasaport Ön",
    "booking.passport_back": "Pasaport Arka",
    "booking.address": "Adres",
    "booking.has_pet": "Evcil hayvanınız var mı?",
    "booking.city": "Şehir",
    "booking.country": "Ülke",
    "booking.town_of_registry": "Kayıtlı ilçe",
    "booking.city_of_registry": "Kayıtlı il",
    "booking.serial_number": "Seri No",
    "booking.document_type": "Belge Türü",
    "booking.date_of_issue": "Belge veriliş tarihi",
    "booking.date_of_expire": "Geçerlilik tarihi",
    "booking.birth_place": "Doğum Yeri",
    "booking.mother_name": `Anne Adı`,
    "booking.father_name": `Baba Adı`,
    "booking.room_assignment": "Oda Tahsisi",
    "booking.OK": "OK",
    "booking.car_plate": "Araç Plakası",
    "booking.dietary_requirements": "Beslenme Koşulları (varsa)",
    "booking.postal_code": "Posta Kodu",
    "booking.arrival_flight": "Varış Uçuşu",
    "booking.departure_flight": "Gidiş Uçuşu",
    "booking.visa_type": "Vize Tipi",
    "booking.visa_expiry_date": "Vize Bitiş Tarihi",
    "booking.reservation_channel": "Rezervasyon Kanalı",
    "booking.time_of_arrival_at_hotel": "Otele Varış Zamanı",
    "booking.all-reservations": "Hepsi",
    "booking.add-new": "YENI ISTEK",
    "booking.firstname-label": "First Name",
    "booking.lastname-label": "Last Name",
    "booking.internal-notes-label": "Internal Notes",
    "booking.phone-label": "Phone",
    "booking.firstname-placeholder": "First Name",
    "booking.lastname-placeholder": "Last Name",
    "booking.internal-notes-placeholder": "Internal Notes",
    "booking.phone-placeholder": "Telefon Numarası",
    "booking.add-new-modal-title": "Create New Booking",
    "booking.label": "Label",
    "booking.status": "Durum",
    "booking.submit": "Submit",
    "booking.cancel": "Cancel",
    "booking.display-options": "Seçenekleri Görüntüle",
    "booking.room": "Oda",
    "booking.empty_booking_list": "Rezervasyonlar Boş",
    "booking.empty_request_list": "Rezervasyonlar Boş",
    "booking.booking_summary": "Rezervasyon Detayı",
    "booking.checkin": "Arrival",
    "booking.checkout": "Departure",
    "booking.orderby": "Order By : ",
    "booking.status_hotel_guest": "Otel Misafiri",
    "booking.status_future_guest": "Gelecek Misafir",
    "booking.status_awaiting_approval": "Onay Bekliyor",
    "booking.status_invalid_booking": "Geçersiz Rezervasyon",
    "booking.status_checked_out": "Geçmiş Misafir",
    "booking.molainn_keyless_access_status_verified": "ONAYLANDI",
    "booking.molainn_keyless_access_status_pending": "BEKLEMEDE",
    "booking.molainn_keyless_access_status_rejected": "REDDEDİLDİ",
    "booking.molainn_keyless_access_status_expired": "SÜRESİ DOLDU",
    "booking.molainnKeylessAccessWarningMessage": "Kapı açma yetkisi verebilmeniz için konaklama statüsünü Hotel Guest olarak değiştirmeniz gerekmektedir.",
    "booking.hescode": "Hes Kodu",
    "booking.TM6Form_number": "TM6 Form Numarası",
    "bookingDetails.back_button": "Geri",
    "bookingDetails.checkin": "Check-in",
    "bookingDetails.checkout": "Check-out",
    "bookingDetails.hotel_guest": "Otel Misafiri",
    "bookingDetails.future_guest": "Gelecek Misafir",
    "bookingDetails.awaiting_approval": "Onay Bekliyor",
    "bookingDetails.invalid_booking": "Geçersiz Rezervasyon",
    "bookingDetails.checked_out": "Geçmiş Misafir",
    "bookingDetails.room": "Oda",
    "bookingDetails.tp_id": "Üçüncü Şahıs Kaynak ID (PMS - Kaynak ID)",
    "bookingDetails.room_info": "oda bilgisi yok",
    "bookingDetails.last_update": "Son Güncelleme: ",
    "bookingDetails.created_at": "Oluşturulma Tarihi: ",
    "bookingDetails.reservation_number": "Rezervasyon No",
    "bookingDetails.national_identification_number": "Ulusal Kimlik Numarası",
    "bookingDetails.passport_number": "Pasaport Numarası",
    "bookingDetails.birth_date": "Doğum Tarihi",
    "bookingDetails.checkin_checkout": "Checkin / Checkout",
    "bookingDetails.checkin_checkout_time": "Checkin Zamanı / Checkout Zamanı",
    "bookingDetails.keyless_active_switch": "Aktif",
    "bookingDetails.keyless_invoke": "Kartı Temizle",
    "bookingDetails.gender": "Cinsiyet",
    "bookingDetails.genderFemale": "Kadın",
    "bookingDetails.genderMale": "Erkek",
    "bookingDetails.nationality": "Uyruk",
    "booking.wrong_booking_page": "Böyle bir rezervasyon bulunamadı",
    "bookingDetails.check_with_pms": "Oda numarası Pms Kontrol",
    "bookingDetails.check_with_pms_button": "Pms Kontrol",
    "booking.loyalty_program": "Sadakat Programı",
    "bookingDetails.Loyalty_and_preferences": "Sadakat Programı ve Misafir Tercihleri",
    "bookingDetails.loyalty_point": "Sadakat Puanı",
    "bookingDetails.guest_preferences": "Misafir Tercihleri",

    // 08 Easee
    "menu.easee": "EaSee",
    "menu.webeeadmin": "Webee Admin",

    // 09 Template Message
    "template.newTemplate": "Yeni Şablon",
    "template.language": "Dil",
    "template.title": "Başlık",
    "template.text": "Metin",
    "template.choose": "Şablon mesajınızı seçiniz",
    "template.chooseLang": "Dil seçiniz",
    "template.add": "Yeni Şablon Ekle",
    "template.edit": "Şablonu Düzenle",
    "template.save": "Kaydet",
    "template.cancel": "Vazgeç",
    "template.noTemplate": "Bir şablon bulunamadı , lütfen yeni şablon ekleyiniz",
    "template.delete": "Bu şablonu silmek istediğinizden emin misiniz?",
    "template.delete-title": "Şablonu Sil",
    "template.delete-button": "Sil",

    // 10 Ringtone
    "ringTone.sound": "Ses",
    "ringTone.playChoose": "Oynat / Seç",

    /* 11 MODAL */
    "modal.close": "Close",

    // 12 Announcement
    "announcement.popupSubject": "Yeni Özellik: Sorun bildirmenin kolay yolu!",
    "announcement.popupBody":
      "StaffApp ile ilgili herhangi bir sorun ya da öneriniz olması durumunda ayarlar altında yer alan “Problemi Raporla” sekmesine giderek sorunlarınızı destek ekibine kolaylıkla bildirebilirsiniz."
  };
};
